<template>
    <div>
        <admin-user-management :id="id">
        </admin-user-management>
    </div>
</template>

<script>
    import AdminUserManagement from '../../components/administration/AdminUserManagement.vue';

    export default {
        props: {
            id: {
                type: String,
                required: true
            }
        },
        components: {
           AdminUserManagement
        },
        mounted() {
            if (!this.hasEditRights) {
                return this.$router.push(`/unauthorized`);
            }
        },
        computed: {
            hasEditRights() {
                return this.$store.getters.claims.aspNetUser.update;
            }
        }
    };
</script>

<style scoped>
    .selectFile {
        display: none;
    }

    .inlineForm {
        display: inline;
    }
</style>
